import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { DragDropModule } from '@angular/cdk/drag-drop';

import { LeftSidenavComponent } from './left-sidenav/left-sidenav.component';
import { PanelComponent } from './panel/panel.component';
import { SharedModule } from 'shared';
import { LeftWideSidenavComponent } from './left-wide-sidenav/left-wide-sidenav.component';
import { ConfimationDialogComponent } from './confimation-dialog/confimation-dialog.component';
import { ModalComponent } from './modal/modal.component';

@NgModule({
  declarations: [
    ConfimationDialogComponent,
    LeftSidenavComponent,
    LeftWideSidenavComponent,
    ModalComponent,
    PanelComponent,
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    DragDropModule,
    SharedModule,
  ],
  exports: [
    LeftSidenavComponent,
    LeftWideSidenavComponent,
    ModalComponent,
    PanelComponent,
  ],
})
export class LayoutModule {}
